import * as api from '../network/api'

const getDefaultState = () => {
    return {
        webinars: [],
        conferences: [],
        courses: []
    }
}
const state = getDefaultState()

const mutations = {
    setWebinars(state, webinars) {
        state.webinars = webinars
    },
    resetState(state) {
        Object.assign(state, getDefaultState(state))
    }
}

const actions = {
    async getWebinars({ state }, q) {
        const query = q ? q : '?sort=created&reverse=true'
        return api.get(`v1/vod/webinars${query}`).then(({ data }) => {
            state.webinars = data
        })
    },
    async getCourses({ state }, q) {
        const query = q ? q : ''
        return api.get(`v1/vod/courses${query}`).then(({ data }) => {
            state.courses = data
        })
    },
    async getConferences({ state }, q) {
        const query = q ? q : ''
        return api.get(`v1/vod/conferences${query}`).then(({ data }) => {
            state.conferences = data
        })
    },
    async getContent({ state, rootState }) {
        try {
            const isSupport =
                rootState.user.roles &&
                rootState.user.roles[0].type == 'support'
            const visibleQuery = !isSupport ? '(visible=true)' : ''
            state.webinars = (
                await api.get(
                    `v1/vod/webinars?query=(${visibleQuery})&sort=created&reverse=true`
                )
            ).data
            state.conferences = (
                await api.get(`v1/vod/conferences?query=(${visibleQuery})`)
            ).data
            state.courses = (
                await api.get(`v1/vod/courses?query=(${visibleQuery})`)
            ).data
            return Promise.resolve()
        } catch (error) {
            return Promise.reject(error)
        }
    },
    resetStore({ commit }) {
        commit('resetState')
    }
}
const getters = {
    webinarsByType: state => type => {
        return state.webinars.filter(
            w => w.receivers.includes(type) && !w.conference
        )
    },
    webinarsByConference: state => conference => {
        return state.webinars.filter(w => w.conference == conference)
    },
    webinarByUUID: state => uuid => {
        return state.webinars.find(w => w.uuid == uuid)
    },
    allProducts: state => {
        return [...state.webinars, ...state.conferences, ...state.courses]
    },
    productByUUID: state => uuid => {
        const products = [
            ...state.webinars,
            ...state.conferences,
            ...state.courses
        ]
        return products.find(w => w.uuid == uuid)
    },
    conferenceByWebinar: state => webinar => {
        const selectedWebinar = state.webinars.find(w => w.uuid == webinar)
        if (!selectedWebinar) {
            return {}
        }
        return state.conferences.find(c => c.uuid == selectedWebinar.conference)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
